import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { validateVideoUrl } from "../../utils/validation";
const useStyles = makeStyles(theme => ({
  videoContainer: {
    position: "relative",
    paddingTop: "56.25%",
    margin: theme.spacing(0, 0, 10, 0)
  },
  video: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
}));

function SlideOutVideo(props) {
  const classes = useStyles();

  if (validateVideoUrl(props.link).type === "video") {
    return (
      <div className={classes.videoContainer}>
        <video
          src={validateVideoUrl(props.link).url}
          className={classes.video}
          title="video"
          controls
        ></video>
      </div>
    );
  }

  return (
    <div className={classes.videoContainer}>
      <iframe
        src={validateVideoUrl(props.link).url}
        frameBorder="0"
        title="iframe"
        className={classes.video}
      />
    </div>
  );
}

export default SlideOutVideo;

SlideOutVideo.propTypes = {
  link: PropTypes.string
};
